// Hunt profiles (templates): list of reusable hunt-setting profiles with create/duplicate, rename,
// set/unset default and delete, plus a full-page editor (#/templates/<id>) built on HuntForm.create
// with a sticky save bar, unsaved-changes guard and honest "applies to all slots using it" feedback.
'use strict';
(function () {
  const { t, esc } = App;

  App.i18n.add({
    ko: {
      tpl_desc: '사냥 설정을 프로필로 저장해 여러 슬롯에서 똑같이 쓰세요. 프로필을 수정하면 그 프로필을 쓰는 모든 슬롯에 함께 적용됩니다.',
      tpl_new: '새 프로필', tpl_new_title: '새 사냥 프로필',
      tpl_name: '프로필 이름', tpl_name_ph: '예: 저레벨 사냥터', tpl_name_required: '이름을 입력하세요.',
      tpl_source: '시작 방식', tpl_source_empty: '빈 프로필로 시작', tpl_source_copy: '기존 프로필 복제',
      tpl_create: '만들기',
      tpl_default_badge: '기본', tpl_default_help: '기본 프로필은 전용 설정도, 지정된 프로필도 없는 슬롯에 자동으로 적용됩니다.',
      tpl_slots_in_use: '{0}개 슬롯에서 사용 중', tpl_slots_none: '사용 중인 슬롯 없음',
      tpl_edit: '편집', tpl_duplicate: '복제', tpl_rename: '이름 변경', tpl_rename_title: '프로필 이름 변경',
      tpl_set_default: '기본으로 지정', tpl_unset_default: '기본 해제',
      tpl_set_default_title: '기본 프로필로 지정', tpl_unset_default_title: '기본 지정 해제',
      tpl_set_default_msg: "'{0}' 프로필을 기본으로 지정할까요?", tpl_unset_default_msg: "'{0}' 프로필의 기본 지정을 해제할까요?",
      tpl_default_set: '기본 프로필로 지정했습니다.', tpl_default_unset: '기본 지정을 해제했습니다.',
      tpl_copy_suffix: '복사본',
      tpl_delete_title: '프로필 삭제', tpl_delete_msg: "'{0}' 프로필을 삭제할까요?",
      tpl_delete_slots: '이 프로필을 사용 중인 {0}개 슬롯은 기본 프로필로 전환됩니다.',
      tpl_delete_safe: '사용 중인 슬롯이 없어 바로 삭제됩니다.',
      tpl_deleted: '프로필을 삭제했습니다.', tpl_created: '프로필을 만들었습니다.', tpl_renamed: '이름을 변경했습니다.',
      tpl_empty_title: '아직 사냥 프로필이 없습니다', tpl_empty_desc: '프로필을 만들어 여러 슬롯에서 같은 사냥 설정을 공유하세요.',
      tpl_not_found: '프로필을 찾을 수 없습니다.', tpl_back: '← 사냥 프로필',
      tpl_editor_note: '저장하면 이 프로필을 사용하는 모든 슬롯에 즉시 적용됩니다.',
      tpl_discard: '되돌리기', tpl_dirty: '{0}곳 변경됨', tpl_no_changes: '변경사항 없음',
      tpl_saved_applied: '저장했습니다. 이 프로필을 사용하는 슬롯에 적용됩니다.',
      tpl_saved_pushed: '저장했습니다. 실행 중인 슬롯 {0}곳에 전송했습니다.',
      tpl_invalid: '입력값을 확인하세요.', tpl_form_unavailable: '사냥 설정 편집기를 불러올 수 없습니다. 잠시 후 다시 시도하세요.',
      // shared profiles + platform default
      tpl_shared_section: '공용 프로필 (관리자 제공)',
      tpl_shared_section_desc: '관리자가 공개한 사냥 프로필입니다. 내 프로필로 복사해 쓰거나 내용을 볼 수 있습니다.',
      tpl_shared_badge: '공용', tpl_shared_by: '제공: {0}',
      tpl_copy_mine: '내 프로필로 복사', tpl_copied: '내 프로필로 복사했습니다.',
      tpl_view: '보기', tpl_readonly_note: '읽기 전용입니다. 수정하려면 내 프로필로 복사하세요.',
      tpl_make_shared: '공용으로 지정', tpl_unmake_shared: '공용 해제',
      tpl_share_set: '공용 프로필로 전환했습니다.', tpl_share_unset: '공용 지정을 해제했습니다.',
      tpl_unshare_title: '공용 해제', tpl_unshare_msg: "'{0}' 프로필을 공용에서 해제할까요?",
      tpl_unshare_detail: '이 프로필을 쓰던 다른 사용자의 슬롯은 각자 기본 설정으로 전환되고, 관리자 기본 설정이 이 프로필이면 함께 해제됩니다.',
      tpl_platform_default_badge: '관리자 기본 설정',
      tpl_set_platform_default: '기본 설정으로 지정', tpl_clear_platform_default: '기본 설정 해제',
      tpl_set_platform_default_title: '관리자 기본 설정 지정', tpl_clear_platform_default_title: '관리자 기본 설정 해제',
      tpl_set_platform_default_msg: "'{0}' 프로필을 관리자 기본 설정으로 지정할까요?", tpl_clear_platform_default_msg: "'{0}' 프로필의 관리자 기본 설정을 해제할까요?",
      tpl_platform_default_help: '전용 설정도, 내 기본 프로필도 없는 슬롯에 적용됩니다. 설정하면 해당하는 모든 슬롯에 바로 반영됩니다.',
      tpl_platform_default_set: '관리자 기본 설정으로 지정했습니다.', tpl_platform_default_cleared: '관리자 기본 설정을 해제했습니다.'
    },
    'zh-CN': {
      tpl_desc: '把狩猎设置保存为方案，在多个栏位中复用。修改方案会同时应用到所有使用该方案的栏位。',
      tpl_new: '新建方案', tpl_new_title: '新建狩猎方案',
      tpl_name: '方案名称', tpl_name_ph: '例如：低级狩猎场', tpl_name_required: '请输入名称。',
      tpl_source: '起始方式', tpl_source_empty: '从空白方案开始', tpl_source_copy: '复制现有方案',
      tpl_create: '创建',
      tpl_default_badge: '默认', tpl_default_help: '默认方案会自动应用到既无专用设置、也未指定方案的栏位。',
      tpl_slots_in_use: '{0} 个栏位在使用', tpl_slots_none: '暂无栏位使用',
      tpl_edit: '编辑', tpl_duplicate: '复制', tpl_rename: '重命名', tpl_rename_title: '重命名方案',
      tpl_set_default: '设为默认', tpl_unset_default: '取消默认',
      tpl_set_default_title: '设为默认方案', tpl_unset_default_title: '取消默认',
      tpl_set_default_msg: "将方案『{0}』设为默认吗？", tpl_unset_default_msg: "取消方案『{0}』的默认设置吗？",
      tpl_default_set: '已设为默认方案。', tpl_default_unset: '已取消默认设置。',
      tpl_copy_suffix: '副本',
      tpl_delete_title: '删除方案', tpl_delete_msg: "删除方案『{0}』吗？",
      tpl_delete_slots: '正在使用该方案的 {0} 个栏位将切换为默认方案。',
      tpl_delete_safe: '没有栏位在使用，将直接删除。',
      tpl_deleted: '已删除方案。', tpl_created: '已创建方案。', tpl_renamed: '已重命名。',
      tpl_empty_title: '还没有狩猎方案', tpl_empty_desc: '创建方案，在多个栏位间共享同一套狩猎设置。',
      tpl_not_found: '找不到方案。', tpl_back: '← 狩猎方案',
      tpl_editor_note: '保存后会立即应用到所有使用该方案的栏位。',
      tpl_discard: '还原', tpl_dirty: '{0} 处更改', tpl_no_changes: '没有更改',
      tpl_saved_applied: '已保存，将应用到使用该方案的栏位。',
      tpl_saved_pushed: '已保存，已推送到 {0} 个运行中的栏位。',
      tpl_invalid: '请检查输入。', tpl_form_unavailable: '无法加载狩猎设置编辑器，请稍后重试。',
      // shared profiles + platform default
      tpl_shared_section: '公共方案（管理员提供）',
      tpl_shared_section_desc: '管理员公开的狩猎方案。可复制到我的方案使用，或查看其内容。',
      tpl_shared_badge: '公共', tpl_shared_by: '提供：{0}',
      tpl_copy_mine: '复制到我的方案', tpl_copied: '已复制到我的方案。',
      tpl_view: '查看', tpl_readonly_note: '只读。如需修改，请复制到我的方案。',
      tpl_make_shared: '设为公共', tpl_unmake_shared: '取消公共',
      tpl_share_set: '已转为公共方案。', tpl_share_unset: '已取消公共设置。',
      tpl_unshare_title: '取消公共', tpl_unshare_msg: "取消方案『{0}』的公共状态吗？",
      tpl_unshare_detail: '正在使用该方案的其他用户栏位将各自切换为默认设置；若管理员默认设置指向该方案，也会一并清除。',
      tpl_platform_default_badge: '管理员默认设置',
      tpl_set_platform_default: '设为默认设置', tpl_clear_platform_default: '取消默认设置',
      tpl_set_platform_default_title: '设为管理员默认设置', tpl_clear_platform_default_title: '取消管理员默认设置',
      tpl_set_platform_default_msg: "将方案『{0}』设为管理员默认设置吗？", tpl_clear_platform_default_msg: "取消方案『{0}』的管理员默认设置吗？",
      tpl_platform_default_help: '应用到既无专用设置、也无自己默认方案的栏位。设置后会立即应用到所有相关栏位。',
      tpl_platform_default_set: '已设为管理员默认设置。', tpl_platform_default_cleared: '已取消管理员默认设置。'
    }
  });

  (function injectCss() {
    if (document.getElementById('tpl-css')) return;
    const style = document.createElement('style');
    style.id = 'tpl-css';
    style.textContent = `
      .tpl-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 16px; }
      .tpl-card { display: flex; flex-direction: column; }
      .tpl-card .card-body { flex: 1; display: flex; flex-direction: column; gap: 8px; }
      .tpl-card .tpl-name { font-size: 15px; font-weight: 600; overflow-wrap: anywhere; }
      .tpl-card .card-foot { flex-wrap: wrap; justify-content: flex-start; }
      .tpl-star { color: var(--warn); }
      .tpl-skel { height: 150px; }
      .tpl-editor-form { padding-bottom: 8px; }
      .tpl-savebar { position: sticky; bottom: 0; z-index: 20; display: flex; align-items: center; gap: 12px;
        padding: 12px 16px; margin: 0 -24px -24px; background: var(--surface); border-top: 1px solid var(--border-strong); }
      .tpl-savebar .grow { display: flex; align-items: center; gap: 8px; }
      @media (max-width: 900px) { .tpl-savebar { margin: 0 -16px -16px; } }`;
    document.head.appendChild(style);
  })();

  const star = (on) => on ? `<span class="tpl-star" title="${esc(t('tpl_default_badge'))}">⭐</span>` : '';

  // ── list page ──
  App.page('templates', {
    title: () => t('nav_templates'),
    nav: { group: 'main', order: 40, icon: '🎯' },
    async render(root, params) {
      if (params && params[0]) return renderEditor(root, params[0]);
      const isAdmin = !!(App.me && App.me.role === 'admin');
      root.innerHTML = `<div class="page">
        <div class="page-head">
          <div class="titles"><h1>${esc(t('nav_templates'))}</h1><div class="desc">${esc(t('tpl_desc'))}</div></div>
          <div class="actions"><button class="btn primary" id="tplNew">＋ ${esc(t('tpl_new'))}</button></div>
        </div>
        <div class="tpl-grid" id="tplGrid">${Array.from({ length: 3 }, () => '<div class="card skeleton tpl-skel"></div>').join('')}</div>
        <div id="tplSharedWrap" hidden>
          <div class="section-head" style="margin-top:24px"><h2>${esc(t('tpl_shared_section'))}</h2><span class="desc">${esc(t('tpl_shared_section_desc'))}</span></div>
          <div class="tpl-grid" id="tplSharedGrid"></div>
        </div>
      </div>`;

      const grid = App.$('#tplGrid', root);
      const sharedWrap = App.$('#tplSharedWrap', root);
      const sharedGrid = App.$('#tplSharedGrid', root);
      let templates = [];
      let platformDefaultId = null;

      async function load() {
        const r = await App.api('/api/templates');
        if (!r.ok) { grid.innerHTML = `<div class="banner error">${esc(App.errorText(r.data))}</div>`; return; }
        templates = r.data.templates || [];
        platformDefaultId = r.data.platform_default_id != null ? Number(r.data.platform_default_id) : null;
        draw();
      }

      function draw() {
        drawOwn(templates.filter(x => !x.owner));
        drawShared(templates.filter(x => x.shared && x.owner));
      }

      function drawOwn(list) {
        if (!list.length) {
          grid.innerHTML = `<div class="empty-state" style="grid-column:1/-1">
            <div class="empty-icon">🎯</div>
            <p>${esc(t('tpl_empty_title'))}</p>
            <p class="muted small">${esc(t('tpl_empty_desc'))}</p>
            <button class="btn primary" id="tplEmptyNew">＋ ${esc(t('tpl_new'))}</button></div>`;
          App.$('#tplEmptyNew', grid).onclick = () => createDialog();
          return;
        }
        const sorted = list.slice().sort((a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0) || String(a.name).localeCompare(String(b.name)));
        grid.innerHTML = sorted.map(tpl => {
          const count = Number(tpl.slot_count) || 0;
          const isPlatformDefault = platformDefaultId != null && Number(tpl.id) === platformDefaultId;
          return `<div class="card tpl-card" data-id="${esc(tpl.id)}">
            <div class="card-body">
              <div class="row between nowrap">
                <span class="tpl-name">${star(tpl.is_default)} ${esc(tpl.name)}</span>
                <span class="row" style="gap:4px">
                  ${tpl.is_default ? `<span class="badge warn">${esc(t('tpl_default_badge'))}</span>` : ''}
                  ${tpl.shared ? `<span class="badge neutral">${esc(t('tpl_shared_badge'))}</span>` : ''}
                  ${isPlatformDefault ? `<span class="badge info">${esc(t('tpl_platform_default_badge'))}</span>` : ''}
                </span>
              </div>
              <div class="muted small">${count ? esc(t('tpl_slots_in_use', count)) : esc(t('tpl_slots_none'))}</div>
            </div>
            <div class="card-foot">
              <button class="btn secondary sm" data-act="edit">${esc(t('tpl_edit'))}</button>
              <button class="btn ghost sm" data-act="rename">${esc(t('tpl_rename'))}</button>
              <button class="btn ghost sm" data-act="duplicate">${esc(t('tpl_duplicate'))}</button>
              <button class="btn ghost sm" data-act="default">${esc(tpl.is_default ? t('tpl_unset_default') : t('tpl_set_default'))}</button>
              ${isAdmin ? `<button class="btn ghost sm" data-act="share">${esc(tpl.shared ? t('tpl_unmake_shared') : t('tpl_make_shared'))}</button>` : ''}
              ${isAdmin && tpl.shared ? `<button class="btn ghost sm" data-act="pdefault">${esc(isPlatformDefault ? t('tpl_clear_platform_default') : t('tpl_set_platform_default'))}</button>` : ''}
              <button class="btn danger sm" data-act="delete">${esc(t('delete'))}</button>
            </div>
          </div>`;
        }).join('');
        App.$$('.tpl-card', grid).forEach(card => {
          const id = Number(card.dataset.id);
          const tpl = templates.find(x => Number(x.id) === id);
          const isPlatformDefault = platformDefaultId != null && id === platformDefaultId;
          const q = (a) => card.querySelector('[data-act=' + a + ']');
          q('edit').onclick = () => App.navigate('#/templates/' + id);
          q('rename').onclick = () => renameDialog(tpl, load);
          q('duplicate').onclick = () => duplicate(tpl, load);
          q('default').onclick = () => toggleDefault(tpl, load);
          q('delete').onclick = () => removeTemplate(tpl, load);
          const sh = q('share'); if (sh) sh.onclick = () => toggleShared(tpl, load);
          const pd = q('pdefault'); if (pd) pd.onclick = () => togglePlatformDefault(tpl, isPlatformDefault, load);
        });
      }

      function drawShared(list) {
        if (!list.length) { sharedWrap.hidden = true; return; }
        sharedWrap.hidden = false;
        const sorted = list.slice().sort((a, b) => String(a.name).localeCompare(String(b.name)));
        sharedGrid.innerHTML = sorted.map(tpl => {
          const count = Number(tpl.slot_count) || 0;
          const isPlatformDefault = platformDefaultId != null && Number(tpl.id) === platformDefaultId;
          return `<div class="card tpl-card" data-id="${esc(tpl.id)}">
            <div class="card-body">
              <div class="row between nowrap">
                <span class="tpl-name">${esc(tpl.name)}</span>
                ${isPlatformDefault ? `<span class="badge info">${esc(t('tpl_platform_default_badge'))}</span>` : ''}
              </div>
              <div class="muted small">${esc(t('tpl_shared_by', tpl.owner))}</div>
              ${isAdmin ? `<div class="muted small">${count ? esc(t('tpl_slots_in_use', count)) : esc(t('tpl_slots_none'))}</div>` : ''}
            </div>
            <div class="card-foot">
              <button class="btn secondary sm" data-act="copy">${esc(t('tpl_copy_mine'))}</button>
              <button class="btn ghost sm" data-act="view">${esc(t('tpl_view'))}</button>
              ${isAdmin ? `<button class="btn ghost sm" data-act="rename">${esc(t('tpl_rename'))}</button>` : ''}
              ${isAdmin ? `<button class="btn ghost sm" data-act="pdefault">${esc(isPlatformDefault ? t('tpl_clear_platform_default') : t('tpl_set_platform_default'))}</button>` : ''}
              ${isAdmin ? `<button class="btn ghost sm" data-act="share">${esc(t('tpl_unmake_shared'))}</button>` : ''}
              ${isAdmin ? `<button class="btn danger sm" data-act="delete">${esc(t('delete'))}</button>` : ''}
            </div>
          </div>`;
        }).join('');
        App.$$('.tpl-card', sharedGrid).forEach(card => {
          const id = Number(card.dataset.id);
          const tpl = list.find(x => Number(x.id) === id);
          const isPlatformDefault = platformDefaultId != null && id === platformDefaultId;
          const q = (a) => card.querySelector('[data-act=' + a + ']');
          q('copy').onclick = () => copyToMine(tpl, load);
          q('view').onclick = () => App.navigate('#/templates/' + id);
          const rn = q('rename'); if (rn) rn.onclick = () => renameDialog(tpl, load);
          const pd = q('pdefault'); if (pd) pd.onclick = () => togglePlatformDefault(tpl, isPlatformDefault, load);
          const sh = q('share'); if (sh) sh.onclick = () => toggleShared(tpl, load);
          const dl = q('delete'); if (dl) dl.onclick = () => removeTemplate(tpl, load);
        });
      }

      App.$('#tplNew', root).onclick = () => createDialog();
      function createDialog() { openCreateDialog(templates, load); }

      await load();
    }
  });

  function openCreateDialog(templates, done) {
    const opts = templates.map(tpl => `<option value="${esc(tpl.id)}">${esc(tpl.name)}</option>`).join('');
    const dlg = App.dialog({
      title: t('tpl_new_title'),
      body: `<div class="field">
          <label for="tplNewName">${esc(t('tpl_name'))}</label>
          <input id="tplNewName" maxlength="60" placeholder="${esc(t('tpl_name_ph'))}" autofocus>
          <div class="error" id="tplNewErr"></div>
        </div>
        <div class="field">
          <label for="tplNewSource">${esc(t('tpl_source'))}</label>
          <select id="tplNewSource">
            <option value="">${esc(t('tpl_source_empty'))}</option>
            ${templates.length ? `<optgroup label="${esc(t('tpl_source_copy'))}">${opts}</optgroup>` : ''}
          </select>
        </div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('tpl_create'), kind: 'primary', onClick: async () => {
          const name = App.$('#tplNewName', dlg.body).value.trim();
          if (!name) { App.$('#tplNewErr', dlg.body).textContent = t('tpl_name_required'); return false; }
          const srcId = App.$('#tplNewSource', dlg.body).value;
          const src = srcId ? templates.find(x => String(x.id) === srcId) : null;
          const r = await App.api('/api/templates', { method: 'POST', body: { name, settings: (src && src.settings) || {} } });
          if (!r.ok) { App.$('#tplNewErr', dlg.body).textContent = App.errorText(r.data); return false; }
          App.toast(t('tpl_created'));
          const newId = r.data && (r.data.template ? r.data.template.id : r.data.id);
          if (newId) App.navigate('#/templates/' + newId); else await done();
        } }
      ]
    });
  }

  function renameDialog(tpl, done) {
    const dlg = App.dialog({
      title: t('tpl_rename_title'),
      body: `<div class="field"><label for="tplRenameName">${esc(t('tpl_name'))}</label>
        <input id="tplRenameName" maxlength="60" value="${esc(tpl.name)}" autofocus>
        <div class="error" id="tplRenameErr"></div></div>`,
      actions: [
        { label: t('cancel'), kind: 'secondary' },
        { label: t('save'), kind: 'primary', onClick: async () => {
          const name = App.$('#tplRenameName', dlg.body).value.trim();
          if (!name) { App.$('#tplRenameErr', dlg.body).textContent = t('tpl_name_required'); return false; }
          const r = await App.api('/api/templates/' + tpl.id, { method: 'PUT', body: { name } });
          if (!r.ok) { App.$('#tplRenameErr', dlg.body).textContent = App.errorText(r.data); return false; }
          App.toast(t('tpl_renamed'));
          await done();
        } }
      ]
    });
  }

  async function duplicate(tpl, done) {
    const r = await App.api('/api/templates', { method: 'POST', body: { name: tpl.name + ' ' + t('tpl_copy_suffix'), settings: tpl.settings || {} } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('tpl_created'));
    await done();
  }

  async function toggleDefault(tpl, done) {
    const next = !tpl.is_default;
    const ok = await App.confirm({
      title: next ? t('tpl_set_default_title') : t('tpl_unset_default_title'),
      message: next ? t('tpl_set_default_msg', tpl.name) : t('tpl_unset_default_msg', tpl.name),
      detail: t('tpl_default_help'),
      confirm: next ? t('tpl_set_default') : t('tpl_unset_default')
    });
    if (!ok) return;
    const r = await App.api('/api/templates/' + tpl.id, { method: 'PUT', body: { is_default: next } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(next ? t('tpl_default_set') : t('tpl_default_unset'));
    await done();
  }

  async function removeTemplate(tpl, done) {
    const count = Number(tpl.slot_count) || 0;
    const ok = await App.confirm({
      title: t('tpl_delete_title'),
      message: t('tpl_delete_msg', tpl.name),
      detail: count ? t('tpl_delete_slots', count) : t('tpl_delete_safe'),
      confirm: t('delete'), danger: true
    });
    if (!ok) return;
    const r = await App.api('/api/templates/' + tpl.id, { method: 'DELETE' });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('tpl_deleted'));
    await done();
  }

  async function copyToMine(tpl, done) {
    const r = await App.api('/api/templates/' + tpl.id + '/copy', { method: 'POST', body: { name: tpl.name + ' ' + t('tpl_copy_suffix') } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(t('tpl_copied'));
    await done();
  }

  async function toggleShared(tpl, done) {
    const next = !tpl.shared;
    if (!next) {
      const ok = await App.confirm({
        title: t('tpl_unshare_title'),
        message: t('tpl_unshare_msg', tpl.name),
        detail: t('tpl_unshare_detail'),
        confirm: t('tpl_unmake_shared'), danger: true
      });
      if (!ok) return;
    }
    const r = await App.api('/api/templates/' + tpl.id, { method: 'PUT', body: { shared: next } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(next ? t('tpl_share_set') : t('tpl_share_unset'));
    await done();
  }

  async function togglePlatformDefault(tpl, isCurrent, done) {
    const ok = await App.confirm({
      title: isCurrent ? t('tpl_clear_platform_default_title') : t('tpl_set_platform_default_title'),
      message: isCurrent ? t('tpl_clear_platform_default_msg', tpl.name) : t('tpl_set_platform_default_msg', tpl.name),
      detail: t('tpl_platform_default_help'),
      confirm: isCurrent ? t('tpl_clear_platform_default') : t('tpl_set_platform_default')
    });
    if (!ok) return;
    const r = await App.api('/api/admin/platform', { method: 'PUT', body: { default_template_id: isCurrent ? null : Number(tpl.id) } });
    if (!r.ok) { App.toast(App.errorText(r.data), 'error'); return; }
    App.toast(isCurrent ? t('tpl_platform_default_cleared') : t('tpl_platform_default_set'));
    await done();
  }

  // ── editor (#/templates/<id>): rendered by the same 'templates' page when a param is present ──
  async function renderEditor(root, idParam) {
    const id = Number(idParam);
      root.innerHTML = `<div class="page"><div class="card skeleton" style="height:360px"></div></div>`;

      const r = await App.api('/api/templates');
      if (!r.ok) { root.innerHTML = `<div class="page"><div class="banner error">${esc(App.errorText(r.data))}</div></div>`; return; }
      const tpl = (r.data.templates || []).find(x => Number(x.id) === id);
      if (!tpl) {
        root.innerHTML = `<div class="page"><div class="empty-state"><div class="empty-icon">🎯</div>
          <p>${esc(t('tpl_not_found'))}</p><a class="btn secondary" href="#/templates">${esc(t('tpl_back'))}</a></div></div>`;
        return;
      }

      if (!(window.HuntForm && typeof HuntForm.create === 'function')) {
        root.innerHTML = `<div class="page">
          <div class="page-head"><div class="titles">
            <a class="linkish small" href="#/templates">${esc(t('tpl_back'))}</a>
            <h1>${star(tpl.is_default)} ${esc(tpl.name)}</h1></div></div>
          <div class="banner warn">${esc(t('tpl_form_unavailable'))}</div></div>`;
        return;
      }

      const readonly = !!tpl.readonly;
      root.innerHTML = `<div class="page">
        <div class="page-head">
          <div class="titles">
            <a class="linkish small" href="#/templates">${esc(t('tpl_back'))}</a>
            <h1>${star(tpl.is_default)} ${esc(tpl.name)}</h1>
            <div class="desc">${esc(readonly ? (tpl.owner ? t('tpl_shared_by', tpl.owner) : t('tpl_readonly_note')) : t('tpl_editor_note'))}</div>
          </div>
        </div>
        <div class="banner ${readonly ? 'warn' : 'info'}">${esc(readonly ? t('tpl_readonly_note') : t('tpl_editor_note'))}</div>
        <div class="tpl-editor-form" id="tplForm"></div>
        ${readonly ? '' : `<div class="tpl-savebar">
          <span class="grow"><span class="muted small" id="tplDirty">${esc(t('tpl_no_changes'))}</span></span>
          <button class="btn ghost" id="tplReset" disabled>${esc(t('tpl_discard'))}</button>
          <button class="btn primary" id="tplSave" disabled>${esc(t('save'))}</button>
        </div>`}
      </div>`;

      const form = HuntForm.create(App.$('#tplForm', root), {
        settings: tpl.settings || {},
        readOnly: readonly,
        onChange: readonly ? undefined : (n) => updateDirty(n)
      });

      if (readonly) return () => { form.destroy(); };

      const dirtyEl = App.$('#tplDirty', root);
      const resetBtn = App.$('#tplReset', root);
      const saveBtn = App.$('#tplSave', root);

      function updateDirty(n) {
        const count = n != null ? n : form.dirtyCount();
        dirtyEl.textContent = count ? t('tpl_dirty', count) : t('tpl_no_changes');
        saveBtn.disabled = !count;
        resetBtn.disabled = !count;
      }

      App.setLeaveGuard(() => form.isDirty());

      resetBtn.onclick = () => { form.reset(tpl.settings || {}); updateDirty(0); };

      saveBtn.onclick = async () => {
        let settings;
        try { settings = form.collect(); }
        catch (err) {
          if (HuntForm.ValidationError && err instanceof HuntForm.ValidationError) {
            const first = err.errors && err.errors[0];
            App.toast(first ? (first.label ? first.label + ': ' + first.message : first.message) : t('tpl_invalid'), 'error');
          } else { App.toast(t('tpl_invalid'), 'error'); }
          return;
        }
        saveBtn.disabled = true; resetBtn.disabled = true;
        const res = await App.api('/api/templates/' + id, { method: 'PUT', body: { settings } });
        if (!res.ok) { App.toast(App.errorText(res.data), 'error'); updateDirty(); return; }
        tpl.settings = settings;
        form.reset(settings);
        updateDirty(0);
        const pushed = res.data && (res.data.agent_pushed != null ? res.data.agent_pushed : res.data.pushed);
        App.toast(typeof pushed === 'number' && pushed > 0 ? t('tpl_saved_pushed', pushed) : t('tpl_saved_applied'));
      };

      updateDirty(form.dirtyCount());

      return () => { App.setLeaveGuard(null); form.destroy(); };
  }
})();
